(function ($) { // Self Executing function with $ alias for jQuery

    /**
     *  Initialization  similar to include once but since all js is loaded by the browser automatically the all
     *   we have to do is call our functions to initialize them, his is only run in the main configuration file
     */
    $(document).ready(function () {

        if ($('#uo-group-essays-table').length > 0 ){
            window.ulgmGroupManagement.Essays.constructor();

            jQuery('form#uo-groups-essays-management-form').on('click', 'button.essay_approve_single,a.essay_approve_single', function (e) {
                e.preventDefault();
                var essay_id = jQuery(this).attr('id').replace('essay_approve_', '');
                essay_id = essay_id.replace('a_', '');
                if ((typeof essay_id !== 'undefined') && (essay_id != '')) {
                    if (jQuery('form#uo-groups-essays-management-form input#bulk-post-selector-top').length) {
                        jQuery('form#uo-groups-essays-management-form input#bulk-post-selector-top').val(essay_id);
                    }
                    if (jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').length) {
                        jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').val('graded');
                    }
                    //jQuery('form#uo-groups-essays-management-form').submit();
                    var dataVars = $('form#uo-groups-essays-management-form').serialize();
                    window.ulgmGroupManagement.Essays.actionsEssays(dataVars);
                }
            });
            jQuery('form#uo-groups-essays-management-form').on('click','a.delete_essay_single',function(e) {
                e.preventDefault();
                var essay_id = jQuery(this).attr('id').replace('a_essay_trash_', '');

                if ( ( typeof essay_id !== 'undefined' ) && ( essay_id != '' ) ) {
                    if (jQuery('form#uo-groups-essays-management-form input#bulk-post-selector-top').length) {
                        jQuery('form#uo-groups-essays-management-form input#bulk-post-selector-top').val(essay_id);
                    }
                    if (jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').length) {
                        jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').val('trash_essay');
                    }
                    var dataVars = $('form#uo-groups-essays-management-form').serialize();
                    window.ulgmGroupManagement.Essays.actionsEssays(dataVars);
                }
            });


            $('#uo-group-essays-table').on('click','a.edit_essay_single',function(){
                var post_id = $(this).data('essay-id');
                window.ulgmGroupManagement.Essays.editEssaysData(post_id);
            });
            $('body').on('click','button#uo-essay-edit-button',function(){
                window.ulgmGroupManagement.Essays.saveEssaysData();
            });
            $('body').on('click','#uo-essay-update-button',function(){
                window.ulgmGroupManagement.Essays.saveEssaysData();
            });

            var transitionTimeout;
            $( '#uo-group-essays-table tbody' ).on({
                mouseenter: function() {
                    clearTimeout( transitionTimeout );
                    focusedRowActions = $( this ).find( '.row-actions' );
                    // transitionTimeout is necessary for Firefox, but Chrome won't remove the CSS class without a little help.
                    $( '.row-actions' ).not( this ).removeClass( 'visible' );
                    focusedRowActions.addClass( 'visible' );
                },
                mouseleave: function() {
                    // Tabbing between post title and .row-actions links needs a brief pause, otherwise
                    // the .row-actions div gets hidden in transit in some browsers (ahem, Firefox).
                    transitionTimeout = setTimeout( function() {
                        focusedRowActions.removeClass( 'visible' );
                    }, 30 );
                }
            }, 'tr' );
        }
    });


    window.ulgmGroupManagement.Essays = {

        uoTable: null,

        uoTableHidden: null,

        lessonId: 0,

        groupId: 0,

        courseId: 0,

        quizId: 0,

        status: 'ungraded',

        elements: {
            select: {
                group: {
                    element: null,
                    options: null
                },
                course: {
                    element: null,
                    options: null,
                    no_element: null
                },
                lesson: {
                    element: null,
                    options: null,
                    no_element: null
                },
                quiz: {
                    element: null,
                    options: null,
                    no_element: null
                },
                status: {
                    element: null,
                    options: null,
                    no_element: null
                },
            }
        },

        constructor: function () {
            this.elements.select.group.element = $('#uo-group-report-group');
            this.elements.select.course.element = $('#uo-group-report-courses');
            this.elements.select.lesson.element = $('#uo-group-report-lessons');
            this.elements.select.quiz.element = $('#uo-group-report-quizzes');
            this.elements.select.status.element = $('#uo-group-report-status');
            this.elements.select.course.no_element = $('#uo-group-report-nocourses');
            this.elements.select.lesson.no_element = $('#uo-group-report-nolessons');
            this.elements.select.quiz.no_element = $('#uo-group-report-noquizzes');

            this.elements.select.group.options  = $('#uo-group-report-group option');
            this.elements.select.course.options = $('#uo-group-report-courses option');
            this.elements.select.lesson.options   = $('#uo-group-report-lessons option');
            this.elements.select.quiz.options   = $('#uo-group-report-quizzes option');
            this.elements.select.status.options   = $('#uo-group-report-status option');
            this.status = this.elements.select.status.element.val();
            this.createTable();
            this.createTableHidden();
            this.addEvents();
            // Request data
            window.ulgmGroupManagement.Essays.getEssaysData( 0, 0, window.ulgmGroupManagement.Essays.groupId, 0, window.ulgmGroupManagement.Essays.status );
        },

		getParam: function(name) {
			name = name.replace(/[[]/, "\[").replace(/[]]/, "\]");
			var regex = new RegExp("[\?&]" + name + "=([^&#]*)"),
				results = regex.exec(location.search);
			return results === null ? "" : decodeURIComponent(results[1].replace("+", " "));
		},
        createTable: function (data) {

            const $table = document.getElementById( 'uo-group-essays-table' );

            var columns = [
                {
                    data:      'id',
                    title:     groupEssays.localized.idColumn,
                    className: 'ulg-report-cell ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--id',
                },
                {
                    data:      'title',
                    title:     groupEssays.localized.title,
                    visible:   groupEssays.columns_visibilities.title,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--title',
                },
                {
                    data:      'first_name',
                    title:     groupEssays.localized.first_name,
                    visible:   groupEssays.columns_visibilities.first_name,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--first-name',
                },
                {
                    data:      'last_name',
                    title:     groupEssays.localized.last_name,
                    visible:   groupEssays.columns_visibilities.last_name,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--last-name',
                },
                {
                    data:      'author',
                    title:     groupEssays.localized.author,
                    visible:   groupEssays.columns_visibilities.author,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--author',
                },
                {
                    data:      'status',
                    title:     groupEssays.localized.status,
                    visible:   groupEssays.columns_visibilities.status,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--status',
                },
                {
                    data:      'points',
                    title:     groupEssays.localized.points,
                    visible:   groupEssays.columns_visibilities.points,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--points',
                },
                {
                    data:      'question_text',
                    title:     groupEssays.localized.question_text,
                    visible:   groupEssays.columns_visibilities.question_text,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--question-text',
                },
                {
                    data:      'content',
                    title:     groupEssays.localized.content,
                    visible:   groupEssays.columns_visibilities.content,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--content',
                },
                {
                    data:      'assignedCourse',
                    title:     groupEssays.localized.assignedCourse,
                    visible:   groupEssays.columns_visibilities.assignedCourse,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-course',
                },
                {
                    data:      'assignedlesson',
                    title:     groupEssays.localized.assignedlesson,
                    visible:   groupEssays.columns_visibilities.assignedlesson,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-lesson',
                },
                {
                    data:      'assignedquiz',
                    title:     groupEssays.localized.assignedquiz,
                    visible:   groupEssays.columns_visibilities.assignedquiz,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-quiz',
                },
                {
                    data:      'comments',
                    title:     groupEssays.localized.comments,
                    visible:   groupEssays.columns_visibilities.comments,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--comments',
                },
                {
                    data:      'date',
                    title:     groupEssays.localized.date,
                    visible:   groupEssays.columns_visibilities.date,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--date',
                },
            ];

            // Check what column has to be used to sort the table
            let tableOrder = [];
            // Find the index of the column we have to use to sort
            let tableOrderByIndex = columns.findIndex( columnData => columnData.title == ulgmEssayReportShortcode.table.orderBy );

            // If the column doesn't exist, then try to get the default one
            if ( tableOrderByIndex === -1 ) {
                tableOrderByIndex = columns.findIndex( columnData => columnData.data == 'date' );
            }
            // If the one defined by the user, or the default one exists, add it
            if ( tableOrderByIndex !== -1 ) {
                tableOrder = [
                    [
                        tableOrderByIndex, // The ID of the column used to sort, defaults to `date`
                        ulgmEssayReportShortcode.table.order, // Designates the ascending or descending order of the ‘orderby‘ parameter, defaults to `desc`
                    ]
                ];
            }

            const buttonsShared = {
                exportOptions: {
                    columns: ( id, data, node ) => {
                        return this.uoTable.column( id ).visible();
                    },

                    format: {
                        body: function ( data, row, column, node ) {
                            // Check if it's the "Status" column
                            if ( node.classList.contains( 'ulg-report-essays-cell--status' ) ) {
                                // Check if it has the "Approve" button inside
                                if ( node.querySelector( 'button.essay_approve_single' ) ) {
                                    // Replace data. If it has the button, then it's "Ungraded"
                                    data = groupEssays.i18n.ungraded;
                                }
                            }
                            // Check if it's the "Points" column
                            else if ( node.classList.contains( 'ulg-report-essays-cell--points' ) ) {
                                // Check if it has an input
                                const $input = node.querySelector( 'input' );
                                if ( $input ) {
                                    // Format data
                                    data = `${ $input.value } ${ node.innerText.trim() }`;
                                }
                            }
                            // Check if it's the "Date" column
                            else if ( node.classList.contains( 'ulg-report-essays-cell--date' ) ) {
                                // Strips hidden timestamp <span>
                                return data.replace(/\<span\s(?:class\=\"ulg\-hidden\-data\")(.*)\<\/span\>/g, '');
                            }
                            // Format all other columns
                            else {
                                // Remove HTML
                                data = node.innerText.trim();
                            }

                            // Remove HTML
                            return data;
                        }
                    }
                },

                filename: () => {
                    // File name parts
                    const filenameParts = [
                        // Base name
                        groupEssays.i18n.reportBaseName
                    ];

                    // Get the ID of the dropdowns used to set the filters
                    const filtersFields = [
                        'uo-group-report-group',
                        'uo-group-report-courses',
                        'uo-group-report-lessons',
                        'uo-group-report-quizzes',
                        'uo-group-report-status'
                    ];

                    // Get the value of the filters
                    filtersFields.forEach( ( filterID ) => {
                        // Get the field of the filter
                        const $filter = document.getElementById( filterID );

                        try {
                            // Check if it exists
                            if ( $filter ) {
                                // Get the value
                                const filterValue = $filter.value;

                                // Make sure the value is not empty
                                if (
                                    filterValue !== ''
                                    && filterValue != '0'
                                ) {
                                    // Get the TEXT of the option
                                    filenameParts.push(
                                        $filter.querySelector( `option[value="${ filterValue }"]` )
                                            .innerText
                                            .trim()
                                    );
                                }
                            }
                        } catch ( e ) {}
                    } );

                    // Return the name
                    return filenameParts.join( ' - ' );
                }, 
            }

            const reportButtons = [];

            // Check if we have to add the CSV button
            if ( $table.dataset.csv == 'show' ) {
                reportButtons.push( Object.assign( {}, buttonsShared, {
                    extend: 'csv',
                    text: groupEssays.i18n.exportCSV,
                } ) );
            }

            // Check if we have to add the Excel button
            if ( $table.dataset.excel == 'show' ) {
                reportButtons.push( Object.assign( {}, buttonsShared, {
                    extend: 'excelHtml5',
                    text: groupEssays.i18n.exportExcel,
                } ) );
            }

            var tableVars = {
                aLengthMenu: [
                    [15, 30, 60, -1],
                    [15, 30, 60, groupEssays.localized.all]
                ],
                order: tableOrder,
                responsive: true,
                iDisplayLength: 30,
                columns: columns,
                columnDefs: [{
                    "targets": 0,
                    "orderable": false,
                    "searchable": false,
                    'render': function (data, type, full, meta){
                        return '<input type="checkbox" name="post[]" value="' + $('<div/>').text(data).html() + '">';
                    },
                    'checkboxes': {
                        'selectRow': true
                    }
                }],
                select: {
                    style: 'multi',
                    selector: 'td:first-child'
                },
                stateSave: true,

                dom: '<"uo-groups-datatable-header"B>frt<"uo-groups-datatable-footer"lpi>',
                buttons: reportButtons,

            };

            if (null !== this.uoTable) {

                this.uoTable.destroy();

                tableVars.data = data;

                tableVars.columnDefs = [{
                    className: 'uo-groups__cell-checkbox',
                    targets:   [0]
                }];

                tableVars.columns = [
                    {
                        data:      'id',
                        title:     groupEssays.localized.idColumn,
                        className: 'ulg-report-cell ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--id',
                    },
                    {
                        data:      'title',
                        title:     groupEssays.localized.title,
                        visible:   groupEssays.columns_visibilities.title,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--title',
                    },
                    {
                        data:      'first_name',
                        title:     groupEssays.localized.first_name,
                        visible:   groupEssays.columns_visibilities.first_name,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--first-name',
                    },
                    {
                        data:      'last_name',
                        title:     groupEssays.localized.last_name,
                        visible:   groupEssays.columns_visibilities.last_name,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--last-name',
                    },
                    {
                        data:      'author',
                        title:     groupEssays.localized.author,
                        visible:   groupEssays.columns_visibilities.author,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--author',
                    },
                    {
                        data:      'status',
                        title:     groupEssays.localized.status,
                        visible:   groupEssays.columns_visibilities.status,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--status',
                    },
                    {
                        data:      'points',
                        title:     groupEssays.localized.points,
                        visible:   groupEssays.columns_visibilities.points,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--points',
                    },
                    {
                        data:      'question_text',
                        title:     groupEssays.localized.question_text,
                        visible:   groupEssays.columns_visibilities.question_text,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--question-text',
                    },
                    {
                        data:      'content',
                        title:     groupEssays.localized.content,
                        visible:   groupEssays.columns_visibilities.content,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--content',
                    },
                    {
                        data:      'assignedCourse',
                        title:     groupEssays.localized.assignedCourse,
                        visible:   groupEssays.columns_visibilities.assignedCourse,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-course',
                    },
                    {
                        data:      'assignedlesson',
                        title:     groupEssays.localized.assignedlesson,
                        visible:   groupEssays.columns_visibilities.assignedlesson,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-lesson',
                    },
                    {
                        data:      'assignedquiz',
                        title:     groupEssays.localized.assignedquiz,
                        visible:   groupEssays.columns_visibilities.assignedquiz,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-quiz',
                    },
                    {
                        data:      'comments',
                        title:     groupEssays.localized.comments,
                        visible:   groupEssays.columns_visibilities.comments,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--comments',
                    },
                    {
                        data:      'date',
                        title:     groupEssays.localized.date,
                        visible:   groupEssays.columns_visibilities.date,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--date',
                    },
                ];

            }
            tableVars.language = {
                processing:        groupEssays.localized.processing,
                search:            '_INPUT_',
                searchPlaceholder: groupEssays.localized.searchPlaceholder,
                lengthMenu:        groupEssays.localized.lengthMenu,
                info:              groupEssays.localized.info,
                infoEmpty:         groupEssays.localized.infoEmpty,
                infoFiltered:      groupEssays.localized.infoFiltered,
                infoPostFix:       '',
                loadingRecords:    groupEssays.localized.loadingRecords,
                zeroRecords:       groupEssays.localized.zeroRecords,
                emptyTable:        groupEssays.localized.emptyTable,
                paginate: {
                    first:         groupEssays.localized.paginate.first,
                    previous:      groupEssays.localized.paginate.previous,
                    next:          groupEssays.localized.paginate.next,
                    last:          groupEssays.localized.paginate.last
                },
                aria: {
                    sortAscending:  groupEssays.localized.sortAscending,
                    sortDescending: groupEssays.localized.sortDescending
                }
            };

            tableVars.initComplete = function(s,d) {
                jQuery(window.ulgmGroupManagement.Essays.addColumnsFilter(s)).insertAfter('#uo-group-essays-table_filter');
            };

            this.uoTable = jQuery('#uo-group-essays-table');

            if ( jQuery('#uo-group-essays-table').length > 0 ){
                this.uoTable = jQuery('#uo-group-essays-table').DataTable(tableVars);
                new jQuery.fn.dataTable.ColReorder( this.uoTable );
				var search = window.ulgmGroupManagement.Essays.getParam('search');
				// console.log(window.ulgmGroupManagement.Essays.uoTable);
				if (search) window.ulgmGroupManagement.Essays.uoTable.search(search).draw();
            }


        },

        createTableHidden: function (data) {

            var columns = [
                {
                    title:     groupEssays.localized.title,
                    data:      'title',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--title',
                },
                {
                    title:     groupEssays.localized.first_name,
                    data:      'first_name',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--first-name',
                },
                {
                    title:     groupEssays.localized.last_name,
                    data:      'last_name',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--last-name',
                },
                {
                    title:     groupEssays.localized.author,
                    data:      'author',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--author',
                },
                {
                    title:     groupEssays.localized.status,
                    data:      'status',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--status',
                },
                {
                    title:     groupEssays.localized.points,
                    data:      'points',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--points',
                },
                {
                    title:     groupEssays.localized.question_text,
                    data:      'question_text',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--question-text',
                },
                {
                    title:     groupEssays.localized.content,
                    data:      'content',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--content',
                },
                {
                    title:     groupEssays.localized.assignedCourse,
                    data:      'assignedCourse',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-course',
                },
                {
                    title:     groupEssays.localized.assignedlesson,
                    data:      'assignedlesson',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-lesson',
                },
                {
                    title:     groupEssays.localized.assignedquiz,
                    data:      'assignedquiz',
                    orderable: false,
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-quiz',
                },
                {
                    title:     groupEssays.localized.comments,
                    data:      'comments',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--comments',
                },
                {
                    title:     groupEssays.localized.date,
                    data:      'date',
                    className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--date',
                },
            ];

            var tableVars = {
                iDisplayLength: -1,
                columns: columns,
                dom: 'Bfrtip',
                buttons: [
                    {
                        extend: 'csv',
                        text: groupEssays.localized.buttons.csvExport,
                        title: 'lesson-report'
                    }
                ],
                stateSave: true,
                responsive: true,
            };

            if ( $.fn.DataTable.isDataTable( '#uo-lesson-report-table-hidden' ) ){

                $( '#uo-lesson-report-table-hidden' ).DataTable().destroy();

                tableVars.data = data;

                tableVars.columns = [
                    {
                        data:      'id',
                        title:     groupEssays.localized.idColumn,
                        className: 'ulg-report-cell ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--id',
                    },
                    {
                        data:      'title',
                        title:     groupEssays.localized.title,
                        visible:   groupEssays.columns_visibilities.title,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--title',
                    },
                    {
                        data:      'first_name',
                        title:     groupEssays.localized.first_name,
                        visible:   groupEssays.columns_visibilities.first_name,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--first-name',
                    },
                    {
                        data:      'last_name',
                        title:     groupEssays.localized.last_name,
                        visible:   groupEssays.columns_visibilities.last_name,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--last-name',
                    },
                    {
                        data:      'author',
                        title:     groupEssays.localized.author,
                        visible:   groupEssays.columns_visibilities.author,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--author',
                    },
                    {
                        data:      'status',
                        title:     groupEssays.localized.status,
                        visible:   groupEssays.columns_visibilities.status,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--status',
                    },
                    {
                        data:      'points',
                        title:     groupEssays.localized.points,
                        visible:   groupEssays.columns_visibilities.points,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--points',
                    },
                    {
                        data:      'question_text',
                        title:     groupEssays.localized.question_text,
                        visible:   groupEssays.columns_visibilities.question_text,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--question-text',
                    },
                    {
                        data:      'content',
                        title:     groupEssays.localized.content,
                        visible:   groupEssays.columns_visibilities.content,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--content',
                    },
                    {
                        data:      'assignedCourse',
                        title:     groupEssays.localized.assignedCourse,
                        visible:   groupEssays.columns_visibilities.assignedCourse,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-course',
                    },
                    {
                        data:      'assignedlesson',
                        title:     groupEssays.localized.assignedlesson,
                        visible:   groupEssays.columns_visibilities.assignedlesson,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-lesson',
                    },
                    {
                        data:      'assignedquiz',
                        title:     groupEssays.localized.assignedquiz,
                        visible:   groupEssays.columns_visibilities.assignedquiz,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--assigned-quiz',
                    },
                    {
                        data:      'comments',
                        title:     groupEssays.localized.comments,
                        visible:   groupEssays.columns_visibilities.comments,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--comments',
                    },
                    {
                        data:      'date',
                        title:     groupEssays.localized.date,
                        visible:   groupEssays.columns_visibilities.date,
                        className: 'ulg-report-cell ulg-report-essays-cell ulg-report-essays-cell--date',
                    },
                ];

            }

            tableVars.language = {
                processing:        groupEssays.localized.processing,
                search:            '_INPUT_',
                searchPlaceholder: groupEssays.localized.searchPlaceholder,
                lengthMenu:        groupEssays.localized.lengthMenu,
                info:              groupEssays.localized.info,
                infoEmpty:         groupEssays.localized.infoEmpty,
                infoFiltered:      groupEssays.localized.infoFiltered,
                infoPostFix:       '',
                loadingRecords:    groupEssays.localized.loadingRecords,
                zeroRecords:       groupEssays.localized.zeroRecords,
                emptyTable:        groupEssays.localized.emptyTable,
                paginate: {
                    first:         groupEssays.localized.paginate.first,
                    previous:      groupEssays.localized.paginate.previous,
                    next:          groupEssays.localized.paginate.next,
                    last:          groupEssays.localized.paginate.last
                },
                aria: {
                    sortAscending:  groupEssays.localized.sortAscending,
                    sortDescending: groupEssays.localized.sortDescending
                }
            };

            this.uoTableHidden = jQuery('#uo-lesson-report-table-hidden');

            if ( jQuery('#uo-lesson-report-table-hidden').length > 0 ){
                this.uoTableHidden = jQuery('#uo-lesson-report-table-hidden').DataTable(tableVars);
            }

            $('.buttons-csv').show();

        },

        flattenArray: function (array, remove_stats) {

            var flatArray = [];

            jQuery.each(array, function (key, value) {

                var lesson_name = value;
                jQuery.each(value.question, function (key2, value2) {
                    flatArray.push({
                        "title": value.title,
                        "author": value.author,
                        "status": value.status,
                        "points": value.points,
                        "question_text": value.question_text,
                        "content": value.content,
                        "assignedCourse": value.assignedCourse,
                        "assignedlesson": value.assignedlesson,
                        "assignedquiz": value.assignedquiz,
                        "comments": value.comments,
                        "date": value.date,
                    })
                });

            });

            return flatArray;

        },

        create_options: function( source, ids = [] ){
            /*
            * @param source string, values "group", "course", "lesson"
            * @param ids    array,  ids of options that have to be shown
            *
            * @return array of jQuery DOM elements with the option elements
            */

            let options = [];

            // Convert parameters to int
            ids = ids.map( Number );

            // Add empty option
            // if there are more then one option
            if ( ids.length > 1 ){
                ids.push( 0 );
            }

            // Get options by ID
            this.elements.select[ source ].options.each(function(){
                let $this   = $(this).clone(),
                    id      = parseInt( $this.val() );

                $this.show();
                if ( ids.indexOf( id ) != -1 ){
                    options.push( $this );
                }
            });

            // If there is only one option and it's a "Select a x" option
            // Then don't return any option
            if ( options.length == 1 && parseInt( options[ 0 ].val() ) == 0 ){
                options = [];
            }

            // Check if there aren't options selected
            if ( options.length == 0 ){
                // Add the no option
                options.push( this.elements.select[ source ].options.filter( '.ulgm-essays-no-results' ) );
            }

            // Return options
            return options;
        },

        select_option: function( $select, value ){
            /*
            * @param select  dom element
            * @param value   string, value of the option that has to be selected
            */

            // Remove selected property
            $select.find( 'option' ).prop( 'selected', false );

            // Select option with value = @param value
            $select.find( 'option[value="' + value + '"]' ).prop( 'selected', true );
        },
        __select_option: function( $select, index ){
            /*
            * @param select  dom element
            * @param value   string, value of the option that has to be selected
            */

            // Remove selected property
            $select.find( 'option' ).prop( 'selected', false );

            // Select option with value = @param value
            $select.find( 'option[' + index + ']' ).prop( 'selected', true );
        },
        addColumnsFilter: function (state) {
            var colFilter_container = $( `<div id="${ state.sInstance }-filter-columns" class="dataTables-filter-columns"><input class="dataTables-filter-columns-field" id="${ state.sInstance }-filter-columns-field" type="checkbox"><div class="dataTables-filter-columns__toggle"><label for="${ state.sInstance }-filter-columns-field" data-label-enable="${ groupEssays.localized.customizeColumns }" data-label-disable="${ groupEssays.localized.hideCustomizeColumns }"></label></div><div class="dataTables-filter-columns__fields"></div></div>` );
            __this = window.ulgmGroupManagement.Essays;

            if( state.oSavedState !== null ) {

                jQuery.each(state.oSavedState.columns, function (key, value) {
                    if (key > 0) {
                        var title = state.aoColumns[key].sTitle;
                        colFilter_container.find( '.dataTables-filter-columns__fields' ).append(__this.addColumnCheckbox(title, key, value.visible));
                    }
                });
            } else {
                jQuery.each(state.aoColumns, function (key, value) {
                    if (key > 0) {
                        var title = state.aoColumns[key].sTitle;
                        colFilter_container.find( '.dataTables-filter-columns__fields' ).append(__this.addColumnCheckbox(title, key, value.bVisible));
                    }
                });
            }

            return colFilter_container;
        },
        addColumnCheckbox: function (label, column_key, is_visible) {
            var checkbox = jQuery('<input />', {
                type: 'checkbox',
                id: 'dt_' + column_key,
                value: label,
                checked: is_visible
            });
            checkbox.on('change', function (e) {
                // Get the column API object
                var headers = window.ulgmGroupManagement.Essays.uoTable.columns().header();
                var current_check = jQuery(this).attr('value');
                var is_checked = jQuery(this).is(':checked');

                jQuery.each(headers, function (key, selectot) {
                    if (jQuery(selectot).html() === current_check) {
                        var column = window.ulgmGroupManagement.Essays.uoTable.column(key);
                        if (is_checked) {
                            // Toggle the visibility
                            column.visible(true);
                        } else {
                            column.visible(false);
                        }
                    }
                });

            });
            var $label = jQuery('<label/>').append(checkbox).append(label);
            return $label;
        },
        addEvents: function (){
            var _this = this;

            // Handle click on "Select all" control
            $('#uo-groups-essays-management').on('click',' #uo-essays-select-all', function(){
                // Check/uncheck checkboxes for all rows in the table
                $('input[name="post[]"]').prop('checked', this.checked);
                if ($('input[name="post[]"]').is(':checked')) {
                    $('.group-essays-buttons').show();
                } else {
                    $('.group-essays-buttons').hide();
                    $('#uo-essays-select-all').prop('checked', false);
                }
            });

            // Handle click on checkbox to set state of "Select all" control
            $('#uo-group-essays-table tbody').on('change', 'input[name="post[]"]', function(){
                // If checkbox is not checked
                if(!this.checked){
                    var el = $('#uo-essays-select-all').get(0);
                    // If "Select all" control is checked and has 'indeterminate' property
                    if(el && el.checked && ('indeterminate' in el)){
                        // Set visual state of "Select all" control
                        // as 'indeterminate'
                        el.indeterminate = true;
                    }
                }
                if ($('input[name="post[]"]').is(':checked')) {
                    $('.group-essays-buttons').show();
                } else {
                    $('.group-essays-buttons').hide();
                    $('#uo-essays-select-all').prop('checked', false);
                }
            });

            $('#uo-groups-essays-management').on('click','#group-approve-essays-button',function(){
                if (jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').length) {
                    jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').val('approve_essay');
                }
                jQuery('form#uo-groups-essays-management-form').submit();
            });

            $('#uo-groups-essays-management').on('click','#group-trash-essays-button',function(){
                if (jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').length) {
                    jQuery('form#uo-groups-essays-management-form input#bulk-action-selector-top').val('trash_essay');
                }
                jQuery('form#uo-groups-essays-management-form').submit();
            });

            // Listen changes to the "Group" dropdown
            this.elements.select.group.element.on( 'change', function(){
                // Save this DOM element
                let $this = $( this );

                // DEBUG: console.log( '--------- GROUP ---------' );
                // DEBUG: console.log( '-- GROUP: Value changed' );

                // COURSE: Show
                // _this.elements.select.course.element.show();

                // Group ID
                let group_id = $this.val();

                // Check if the group ID is empty ("Select an option")
                if ( group_id == 0 || group_id == null ){
                    // COURSE: Remove all the options
                    _this.elements.select.course.element.empty();
                    // COURSE: Get the "Select course" option
                    let options_course = _this.create_options( 'course' );
                    // COURSE: Set the options
                    _this.elements.select.course.element.html( options_course );

                    // LESSON: Remove all the options
                    _this.elements.select.lesson.element.empty();
                    // LESSON: Get the "Select lesson" option
                    let options = _this.create_options( 'lesson' );
                    // LESSON: Set the options
                    _this.elements.select.lesson.element.html( options );

                    // QUIZ: Get the "Select lesson" option
                    let options_quiz = _this.create_options( 'quiz' );
                    // QUIZ: Get the "Select lesson" option
                    _this.elements.select.quiz.element.html( options_quiz );

                    // Render the tables again
                    window.ulgmGroupManagement.Essays.createTable([]);
                    window.ulgmGroupManagement.Essays.createTableHidden([]);

                    // Return
                    return;
                }

                // Get the relationships
                let courses_to_show = groupEssays.courseGrouplessons[ group_id ];
                courses_to_show     = courses_to_show === undefined ? [] : courses_to_show;

                // Create the options
                let options = _this.create_options( 'course', courses_to_show );

                // Check if the options are valid options
                let hasValidOptions = options.reduce(( accumulator, currentValue ) => {
                    return accumulator && currentValue.val() !== '';
                }, true );

                if ( hasValidOptions && options.length > 0 ){
                    // DEBUG: console.log( '-- COURSES: There are courses' );
                    // DEBUG: console.log( '-- COURSES: Hide the no results option' );

                    // COURSE: Hide the "no results" option
                    $noResultsOption = _this.elements.select[ 'course' ].element.find( '.ulgm-essays-no-results' );
                    $noResultsOption.hide();

                    // Add the options to the COURSE dropdown
                    _this.elements.select.course.element.html( options );
                    _this.elements.select.course.no_element.hide();

                    // Select the empty option
                    _this.__select_option( _this.elements.select.course.element, 0 );

                    // Check if there is only one available course
                    if ( options.length == 1 ){
                        // DEBUG: console.log( '---- COURSES: Only one course found.' );

                        // Add the "h3-select" class, so it doesn't look like a select
                        _this.elements.select[ 'course' ].element.addClass( 'h3-select' );

                        // Disable the select
                        _this.elements.select.course.element.prop( 'disabled', true );
                    }
                    else {
                        // Remove the "h3-select" class, so it looks like a select
                        _this.elements.select[ 'course' ].element.removeClass( 'h3-select' );

                        // Enable the select
                        _this.elements.select.course.element.prop( 'disabled', false );
                    }

                    // Save data in main object
                    window.ulgmGroupManagement.Essays.groupId = group_id;
                    // Trigger change after value set on load
                    _this.elements.select.course.element.trigger( 'change' );
                }
                else {
                    // DEBUG: console.log( '-- COURSES: There are NOT courses' );

                    // Remove the "h3-select" class, so it looks like a select
                    _this.elements.select[ 'course' ].element.removeClass( 'h3-select' );

                    // Hide "Select course" dropdown, the empty option was selected
                    // _this.elements.select.course.element.empty();

                    let options_course = _this.create_options( 'course' );
                    _this.elements.select.course.element.html( options_course );
                    _this.elements.select.course.element.prop( 'disabled', true );

                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson' );
                    _this.elements.select.lesson.element.html( options );
                    _this.elements.select.lesson.element.prop( 'disabled', true );

                    let options_quiz = _this.create_options( 'quiz' );
                    _this.elements.select.quiz.element.html( options_quiz );
                    _this.elements.select.quiz.element.prop( 'disabled', true );

                    // Render the table again
                    window.ulgmGroupManagement.Essays.createTable([]);
                    window.ulgmGroupManagement.Essays.createTableHidden([]);

                    // Save data in main object
                    window.ulgmGroupManagement.Essays.groupId = group_id;

                    // COURSE: Show the "no results" option
                    $noResultsOption = _this.elements.select[ 'course' ].element.find( '.ulgm-essays-no-results' );
                    $noResultsOption.show();
                }

                // Request data
                window.ulgmGroupManagement.Essays.getEssaysData( 0, 0, window.ulgmGroupManagement.Essays.groupId, 0, window.ulgmGroupManagement.Essays.status );
            });

            this.elements.select.course.element.on( 'change', function(){
                // Save this DOM element
                let $this = $(this);

                // DEBUG: console.log( '--------- COURSE ---------' );
                // DEBUG: console.log( '-- COURSE: Value changed' );

                // Course ID
                let course_id = $this.val();

                // Return if course id is 0
                if ( course_id == 0 || course_id == '' ){
                    _this.elements.select.lesson.element.empty();

                    let options = _this.create_options( 'lesson' );
                    _this.elements.select.lesson.element.html( options );
                    _this.elements.select.lesson.element.prop( 'disabled', true );

                    let options_quiz = _this.create_options( 'quiz' );
                    _this.elements.select.quiz.element.html( options_quiz );
                    _this.elements.select.quiz.element.prop( 'disabled', true );

                    window.ulgmGroupManagement.Essays.createTable([]);
                    window.ulgmGroupManagement.Essays.createTableHidden([]);
                    return;
                }

                // Get relationships
                let lessons_to_show = groupEssays.relationships[ window.ulgmGroupManagement.Essays.groupId ][ course_id ];

                lessons_to_show = lessons_to_show === undefined ? [] : lessons_to_show;

                // Create options
                let options = _this.create_options( 'lesson', lessons_to_show );

                // Check if the options are valid options
                let hasValidOptions = options.reduce(( accumulator, currentValue ) => {
                    return accumulator && currentValue.val() !== '';
                }, true );

                if ( hasValidOptions && options.length > 0 ){
                    // DEBUG: console.log( '-- LESSONS: There are lessons' );

                    // Show "Select lesson" dropdown
                    _this.elements.select.lesson.element.show();
                    _this.elements.select.lesson.element.html( options );
                    _this.elements.select.lesson.element.prop( 'disabled', false );

                    jQuery( '#uo-group-report-lessons option' ).show();
                    _this.elements.select.lesson.no_element.hide();

                    // Check if there is only one available course
                    if ( options.length == 1 ){
                        // DEBUG: console.log( '---- LESSON: Only one lesson found.' );

                        // Add the "h3-select" class, so it doesn't look like a select
                        _this.elements.select[ 'lesson' ].element.addClass( 'h3-select' );

                        // Disable the select
                        _this.elements.select.lesson.element.prop( 'disabled', true );
                    }
                    else {
                        // Remove the "h3-select" class, so it looks like a select
                        _this.elements.select[ 'lesson' ].element.removeClass( 'h3-select' );

                        // Enable the select
                        _this.elements.select.lesson.element.prop( 'disabled', false );
                    }

                    // Select empty option
                    _this.__select_option( _this.elements.select.lesson.element, 0 );

                    // Save data in main object
                    window.ulgmGroupManagement.Essays.courseId = course_id;
                    // trigger change after value set on load
                    _this.elements.select.lesson.element.trigger( 'change' );
                }
                else {
                    // DEBUG: console.log( '-- LESSONS: There are NOT lessons' );

                    // Hide "Select course" dropdown, the empty option was selected
                    _this.elements.select.lesson.element.empty();
                    let options = _this.create_options( 'lesson' );
                    _this.elements.select.lesson.element.html( options );
                    _this.elements.select.lesson.element.prop( 'disabled', true );

                    window.ulgmGroupManagement.Essays.createTable([]);
                    window.ulgmGroupManagement.Essays.createTableHidden([]);
                    // Save data in main object
                    window.ulgmGroupManagement.Essays.courseId = course_id;
                    // Request data
                    window.ulgmGroupManagement.Essays.getEssaysData( 0, window.ulgmGroupManagement.Essays.courseId, window.ulgmGroupManagement.Essays.groupId, 0, window.ulgmGroupManagement.Essays.status  );
                }

                // Get relationships
                let quizzes_to_show = groupEssays.quiz_relationships[ window.ulgmGroupManagement.Essays.groupId ][ course_id ];
                quizzes_to_show = quizzes_to_show === undefined ? [] : quizzes_to_show;

                // Create options
                let options_quizzes = _this.create_options( 'quiz', quizzes_to_show );

                // Check if the options are valid options
                let hasValidOptionsQuizzes = options_quizzes.reduce(( accumulator, currentValue ) => {
                    return accumulator && currentValue.val() !== '';
                }, true );

                if ( hasValidOptionsQuizzes && options_quizzes.length > 0 ){
                    // DEBUG: console.log( '-- QUIZZES: There are quizzes' );

                    // Show "Select lesson" dropdown
                    _this.elements.select.quiz.element.show();
                    _this.elements.select.quiz.element.html( options_quizzes );
                    _this.elements.select.quiz.element.prop( 'disabled', true );
                    jQuery('#uo-group-report-quizzes option').show();
                    _this.elements.select.quiz.no_element.hide();

                    // Check if there is only one available course
                    if ( options_quizzes.length == 1 ){
                        // DEBUG: console.log( '---- QUIZZES: Only one quiz found.' );

                        // Add the "h3-select" class, so it doesn't look like a select
                        _this.elements.select[ 'quiz' ].element.addClass( 'h3-select' );

                        // Disable the select
                        _this.elements.select.quiz.element.prop( 'disabled', true );
                    }
                    else {
                        // Remove the "h3-select" class, so it looks like a select
                        _this.elements.select[ 'quiz' ].element.removeClass( 'h3-select' );

                        // Enable the select
                        _this.elements.select.quiz.element.prop( 'disabled', false );
                    }

                    // Select empty option
                    _this.__select_option( _this.elements.select.quiz.element, 0 );

                    // Save data in main object
                    window.ulgmGroupManagement.Essays.courseId = course_id;
                    // trigger change after value set on load
                    _this.elements.select.quiz.element.trigger( 'change' );
                }
                else {
                    // DEBUG: console.log( '-- QUIZZES: There are NOT quizzes' );

                    // Hide "Select course" dropdown, the empty option was selected
                    _this.elements.select.quiz.element.empty();
                    let options = _this.create_options( 'quiz' );
                    _this.elements.select.quiz.element.html( options );
                    _this.elements.select.quiz.element.prop( 'disabled', true );
                    window.ulgmGroupManagement.Essays.createTable( [] );
                    window.ulgmGroupManagement.Essays.createTableHidden( [] );
                    // Save data in main object
                    window.ulgmGroupManagement.Essays.courseId = course_id;
                    // Request data
                    window.ulgmGroupManagement.Essays.getEssaysData( 0, window.ulgmGroupManagement.Essays.courseId, window.ulgmGroupManagement.Essays.groupId, 0, window.ulgmGroupManagement.Essays.status  );
                }
            });

            this.elements.select.lesson.element.on( 'change', function(){
                // Save this DOM element
                let $this = $(this);

                // DEBUG: console.log( '--------- LESSON ---------' );
                // DEBUG: console.log( '-- LESSON: Value changed' );

                // lesson ID
                let lesson_id = $this.val();
                // Save data in main object
                window.ulgmGroupManagement.Essays.lessonId = lesson_id;

                // Request data
                window.ulgmGroupManagement.Essays.getEssaysData( lesson_id, window.ulgmGroupManagement.Essays.courseId, window.ulgmGroupManagement.Essays.groupId, 0, window.ulgmGroupManagement.Essays.status  );
            });

            this.elements.select.quiz.element.on( 'change', function(){
                // Save this DOM element
                let $this = $(this);
                // lesson ID
                let quiz_id = $this.val();
                // Save data in main object
                window.ulgmGroupManagement.Essays.quizId = quiz_id;

                // DEBUG: console.log( '--------- QUIZ ---------' );
                // DEBUG: console.log( '-- QUIZ: Value changed' );

                // Request data
                window.ulgmGroupManagement.Essays.getEssaysData( 0, window.ulgmGroupManagement.Essays.courseId, window.ulgmGroupManagement.Essays.groupId, window.ulgmGroupManagement.Essays.quizId, window.ulgmGroupManagement.Essays.status );
            });

            this.elements.select.status.element.on( 'change', function(){
                // DEBUG: console.log( '--------- STATUS ---------' );
                // DEBUG: console.log( '-- STATUS: Value changed' );

                // Save this DOM element
                let $this = $(this);
                // lesson ID
                let status = $this.val();
                // Save data in main object
                window.ulgmGroupManagement.Essays.status = status;

                // Request data
                window.ulgmGroupManagement.Essays.getEssaysData( 0, window.ulgmGroupManagement.Essays.courseId, window.ulgmGroupManagement.Essays.groupId, window.ulgmGroupManagement.Essays.quizId, window.ulgmGroupManagement.Essays.status );
            });

            // Trigger a change event on the groups dropdown on page load
            this.elements.select.group.element.trigger( 'change' );

            // Add event listener for opening and closing details
            $('#uo-lesson-report-table').on('click', 'td.details-control', function () {

                var tr = $(this).closest('tr');
                var row = window.ulgmGroupManagement.Essays.uoTable.row(tr);

                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(window.ulgmGroupManagement.Essays.format(row.data())).show();
                    tr.addClass('shown');
                }
            });

        },

        format: function (d) {

            var rows = '';
            $.each(d.answer, function (key, value) {
                rows +=
                    '<tr>' +
                    '<td>' + d.question[key] + '</td>' +
                    '<td>' + value + '</td>' +
                    '</tr>';
            });
            // `d` is the original data object for the row
            return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' + rows + '</table>';
        },
        isNormalInteger: function (str) {
            var n = ~~Number(str);
            return String(n) === str && n > 0;
        },

        getEssaysData: function (lessonId, courseId, groupId, quizId, status) {

            var i = 0;

            var loading = setInterval(function () {
                i = ++i % 4;
                $("#uo-group-essays-table tbody").html("<div id='group-loader'>" + groupEssays.localized.loadingRecords + new Array(i + 1).join(".") + "</div>");
            }, 500);


            var dataVars = {
                groupId: groupId,
                lessonId: lessonId,
                quizId: quizId,
                courseId: courseId,
                status:status,
            };

            $.ajax({

                method: "POST",
                data: dataVars,
                url: groupEssays.root + 'get_essays_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupEssays.nonce);
                },
                success: function (response) {

                    clearInterval(loading);
                    $('#group-loader').remove();

                    window.ulgmGroupManagement.Essays.createTable(response);
                    window.ulgmGroupManagement.Essays.createTableHidden(response);


                },
                fail: function (response) {
                    alert('Rest Call Failed');
                }

            });

        },
        editEssaysData: function (postId) {
            var spinner = $('.uo-modal-spinner');
            spinner.show();
            var dataVars = {
                essay_id: postId,
                action: 'edit_essays',
                post_type:'sfwd-essay',
                security:groupEssays.ajax_nonce
            };

            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupEssays.root + 'edit_essays_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupEssays.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    $(".modal").remove();
                    $(response.html).appendTo('body').modal();
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        },
        saveEssaysData: function () {
            if (typeof tinymce !== 'undefined') {
                for (edId in tinyMCE.editors) {
                    if (
                        typeof tinyMCE.editors[edId] !== 'undefined' &&
                        typeof tinyMCE.editors[edId].save !== 'undefined' &&
                        tinyMCE.editors[edId].save instanceof Function) {
                        tinyMCE.editors[edId].save();
                    }
                }

            }
            var dataVars = $('#edit_essay_form').serialize();
            var spinner = $('.uo-modal-spinner');
            //$('#group-management-message').hide();
            $('.uo-groups-message-ok').hide();
            spinner.show();
            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupEssays.root + 'save_essays_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupEssays.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    window.ulgmGroupManagement.Essays.elements.select.lesson.element.trigger('change');
                    //$('#group-management-message').html(response.message).show();
                    $('.uo-groups-message-ok').html(response.message).show();
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        },
        actionsEssays: function ( dataVars ) {
            var spinner = $('.uo-modal-spinner');
            spinner.show();
            $.ajax({
                method: "POST",
                data: dataVars,
                url: groupEssays.root + 'save_essays_data/',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', groupEssays.nonce);
                },
                success: function (response) {
                    spinner.hide();
                    window.ulgmGroupManagement.Essays.elements.select.lesson.element.trigger('change');
                },
                fail: function (response) {
                    spinner.hide();
                    alert('Rest Call Failed');
                }
            });
        }
    };


})(jQuery);
